import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'
import type { Parameter, TypeUsage } from '@/core/types/library.type'
import { getUnifiedGraftModelType } from '@/core/utils/getUnifiedGraftModelType'

import { hasPayload } from './formatTypeUsage/nodeHelpers'
import { safeString } from './safeString'

function isTypeUsagePayload(value: unknown): value is TypeUsage {
  if (!hasPayload(value)) return false

  const kind = getUnifiedGraftModelType(value as { unifiedGraftModelType?: unknown; graftModelType?: unknown })

  if (kind === UnifiedGraftModelTypeKey.TYPE_USAGE) return true

  return typeof kind === 'string' && kind.startsWith('TYPE_USAGE')
}

/** PARAMETER payload is usually [TYPE_USAGE, NAME]; some runtimes (e.g. PHP globals) use [NAME, TYPE_USAGE]. */
export function parseParameterPayload(param: Parameter): { typeUsage: TypeUsage; name: string } {
  const [first, second] = param.payload

  if (isTypeUsagePayload(first) && typeof second === 'string') {
    return { typeUsage: first, name: second }
  }

  if (typeof first === 'string' && isTypeUsagePayload(second)) {
    return { typeUsage: second, name: first }
  }

  return { typeUsage: first as TypeUsage, name: safeString(second) }
}
